module.exports = __webpack_public_path__ + "static/media/jackpot_empty.8a101dbc.svg";